// @flow
import * as React from 'react';
import { List } from 'immutable';
import {
  type ClientProps,
  ClientContext,
} from 'containers/client/ClientProvider';
import { EmptyCard, Select } from 'components';
import GetAccess from './GetAccess';
import SafariCookiePage from './SafariCookiePage';

const IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

type SocialCollectionOption = {|
  label: string,
  catalog_id: number,
  value: string,
|};

type ContainerProps = {
  title: string,
  iframeSrc: string => string,
};

type ViewProps = ContainerProps & {
  selectedOption: SocialCollectionOption,
  options: Array<SocialCollectionOption>,
  selectClientCatalog: number => void,
};

type ViewState = {
  displayState:
    | 'LOADING'
    | 'PAGE_CONTENT'
    | 'SAFARI_COOKIE_SCREEN'
    | 'SAFARI_ERROR',
};

class WyngView extends React.PureComponent<ViewProps, ViewState> {
  state = {
    displayState: 'LOADING',
  };

  componentDidMount() {
    if (IS_SAFARI) {
      fetch('https://wyng.com/auth/set-test-cookie/', {
        credentials: 'include',
      })
        .then(() =>
          fetch('https://wyng.com/auth/test-cookie-worked/', {
            credentials: 'include',
          })
        )
        .then(response => response.json())
        .then(response => {
          this.setState({
            displayState:
              response && response.successful
                ? 'PAGE_CONTENT'
                : 'SAFARI_COOKIE_SCREEN',
          });
        })
        .catch(() => {
          this.setState({ displayState: 'SAFARI_ERROR' });
        });
    } else {
      this.setState({ displayState: 'PAGE_CONTENT' });
    }
  }

  handleChange = (selectedOption: SocialCollectionOption) => {
    selectedOption && this.props.selectClientCatalog(selectedOption.catalog_id);
  };

  render() {
    const { title, iframeSrc, options, selectedOption } = this.props;
    const { displayState } = this.state;

    if (displayState === 'LOADING') {
      return <EmptyCard message="Loading Social Collection..." />;
    }
    if (displayState === 'SAFARI_COOKIE_SCREEN') {
      return <SafariCookiePage />;
    }
    if (displayState === 'SAFARI_ERROR') {
      return (
        <EmptyCard
          title="Social Collection in Safari"
          message="It appears there was an error trying to open Social Collection in Safari. Please try using another browser."
        />
      );
    }

    if (options.length) {
      return (
        <React.Fragment>
          <Select
            className="mb3 mw5"
            clearable={false}
            value={selectedOption}
            options={options}
            onChange={this.handleChange}
          />
          <iframe
            name="powerreviews"
            title={title}
            className="w-100 shadow-1 bn vh-75 mb2"
            src={iframeSrc(selectedOption.value)}
          />
          <span className="gray">Powered by Wyng</span>
        </React.Fragment>
      );
    } else {
      return <GetAccess />;
    }
  }
}

const WyngContainer = (props: ContainerProps) => {
  return (
    <ClientContext.Consumer>
      {(clientProps: ClientProps) => {
        if (!clientProps) return null;
        if (clientProps.catalogs instanceof Error) {
          return (
            <EmptyCard
              title="No Catalogs"
              message="Seems like we encountered an error loading the catalogs associated with the above client. Please contact PowerReviews Support for help."
            />
          );
        }
        if (!(clientProps.catalogs instanceof List)) return null;

        const options = clientProps.catalogs
          .filter(catalog => catalog.social_collection_property_id)
          .map(catalog => {
            return {
              value: catalog.social_collection_property_id,
              label: catalog.name,
              catalog_id: catalog.catalog_id,
            };
          })
          .toArray();
        const selectedOption =
          options.find(opt => opt.catalog_id === clientProps.catalogId) ||
          options[0];

        return (
          <WyngView
            options={options}
            selectedOption={selectedOption}
            selectClientCatalog={clientProps.selectClientCatalog}
            title={props.title}
            iframeSrc={props.iframeSrc}
          />
        );
      }}
    </ClientContext.Consumer>
  );
};

export default WyngContainer;



// WEBPACK FOOTER //
// ./src/containers/socialcollection/WyngContent.js